export const MAX_AI_ALERT_SUBSCRIPTIONS_COUNT = 10;

export const LIMIT_REACHED_VERBIAGE = {
  bodyText:
    'You’ve reached your limit for AI email notifications. Please delete existing notifications before adding more.',
  cancelText: null,
  confirmText: 'View notification settings',
  confirmingText: null,
  headerText: 'Limit reached',
};

export const SUBSCRIBE_VERBIAGE = {
  bodyText:
    'Subscribe to receive an email when new reporting updates this response. You can unsubscribe later from Deep Research settings.',
  cancelText: 'Cancel',
  confirmText: 'Subscribe',
  confirmingText: 'Subscribing…',
  headerText: 'Get updates',
};

export const UNSUBSCRIBE_VERBIAGE = {
  bodyText:
    'Unsubscribe from this notification. You can resubscribe later from the original query in your research history.',
  cancelText: 'Cancel',
  confirmText: 'Unsubscribe',
  confirmingText: 'Unsubscribing…',
  headerText: 'Delete notification',
};
